var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { TabContext, TabPanel, useTabContext, } from "@material-ui/lab";
import { Box, Paper, Tab, Tabs, useMediaQuery, useTheme, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
var useCssTabStyles = makeStyles(function (theme) {
    var _a;
    return ({
        panelBox: (_a = {
                display: function (_a) {
                    var selected = _a.selected;
                    return (selected ? "block" : "none");
                },
                padding: 0,
                marginTop: theme.spacing(2)
            },
            _a[theme.breakpoints.up("md")] = {
                padding: theme.spacing(3),
                marginTop: theme.spacing(0),
            },
            _a),
    });
});
var CssTabPanel = function (props) {
    var context = useTabContext();
    var classes = useCssTabStyles({ selected: (context === null || context === void 0 ? void 0 : context.value) === props.value });
    return React.createElement(Box, { className: classes.panelBox }, props.children);
};
export var PaperTabLayout = function (_a) {
    var defaultValue = _a.defaultValue, tabs = _a.tabs, _b = _a.keepMounted, keepMounted = _b === void 0 ? false : _b, _c = _a.mobileVariant, mobileVariant = _c === void 0 ? "scrollable" : _c;
    var theme = useTheme();
    var _d = __read(React.useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : tabs[0].label), 2), value = _d[0], setValue = _d[1];
    var onTabChange = function (_, tab) { return setValue(tab); };
    var showScrollableVariant = useMediaQuery(theme.breakpoints.down("xs"), {
        noSsr: true,
    });
    var TabPanelComponent = keepMounted ? CssTabPanel : TabPanel;
    return (React.createElement(TabContext, { value: value },
        React.createElement(Box, { component: Paper, width: "100%" },
            React.createElement(Tabs, { value: value, indicatorColor: "primary", textColor: "primary", onChange: onTabChange, variant: showScrollableVariant ? mobileVariant : "fullWidth" }, tabs.map(function (_a) {
                var label = _a.label;
                return (React.createElement(Tab, { key: label, value: label, label: label }));
            }))),
        React.createElement(Box, null, tabs.map(function (_a) {
            var node = _a.node, label = _a.label;
            return (React.createElement(TabPanelComponent, { key: label, value: label }, node));
        }))));
};
